import _ from "lodash";
import securityManager from "../../../services/managers/security";
import envManager from "../../../services/managers/env";
import { COST_TO_TRADE_LOT_SIZES_MIN_LIMIT, COST_TO_TRADE_LOT_SIZES_MAX_LIMIT, SELECT_EMPTY_VALUE } from "../../../services/managers/constants";

export const onSelectedCostToTradeLotSizesChange = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let whiteboard = { ...chartWhiteboards[action.payload.whiteboardIndex] };
  let selectedCostToTradeLotSizes = whiteboard.selectedCostToTradeLotSizes.slice();

  // When overlay comparison is active
  if (
    whiteboard.selectedComparisonChart &&
    whiteboard.selectedComparisonChart !== SELECT_EMPTY_VALUE &&
    !envManager.areMultipleLotSizesAllowedForOverlayComparison()
  ) {
    selectedCostToTradeLotSizes = [];
    selectedCostToTradeLotSizes.push(action.payload.value);
    whiteboard.selectedCostToTradeLotSizes = selectedCostToTradeLotSizes;

    // Obsoleting Whiteboard
    whiteboard.isObsolete = true;
    whiteboard.__change_detection_key = securityManager.generateKey();
    chartWhiteboards[action.payload.whiteboardIndex] = whiteboard;

    return { ...state, chartWhiteboards };
  }

  // When overlay comparison is not active
  if (_.includes(selectedCostToTradeLotSizes, action.payload.value)) {
    // On deselection
    if (whiteboard.selectedCostToTradeLotSizes.length > COST_TO_TRADE_LOT_SIZES_MIN_LIMIT) {
      selectedCostToTradeLotSizes = _.pull(selectedCostToTradeLotSizes, action.payload.value);
    }
  } else {
    // On selection
    if (whiteboard.selectedCostToTradeLotSizes.length < COST_TO_TRADE_LOT_SIZES_MAX_LIMIT) {
      selectedCostToTradeLotSizes.push(action.payload.value);
    }
  }

  if (whiteboard.selectedCostToTradeLotSizes.length === selectedCostToTradeLotSizes.length) {
    // No new Lot Size has been added or removed
    return { ...state };
  } else {
    // New Lot Size has either been added or removed
    whiteboard.selectedCostToTradeLotSizes = selectedCostToTradeLotSizes;
    // Obsoleting Whiteboard
    whiteboard.isObsolete = true;
    whiteboard.__change_detection_key = securityManager.generateKey();
    chartWhiteboards[action.payload.whiteboardIndex] = whiteboard;

    return { ...state, chartWhiteboards };
  }
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-cost-to-trade-lot-sizes/action-handlers.js